import { render, staticRenderFns } from "./PageOrgAddressBook.vue?vue&type=template&id=65acab84&scoped=true"
import script from "./PageOrgAddressBook.vue?vue&type=script&lang=js"
export * from "./PageOrgAddressBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65acab84",
  null
  
)

export default component.exports